import loadable from '@loadable/component';
import Loading from '../../components/Loader';
import { fetchHomepageData } from '../../actions/homepage';
import { fetchAdvertiseRecommendations } from '../../actions/advertise';

const Homepage = loadable(() => import(/* webpackChunkName: "homepage" */ './Container'), {
  loading: Loading
});

Homepage.needs = async (props, { dispatch }) => {
  if (SERVER) return; // eslint-disable-line no-undef
  const homepage = dispatch(fetchHomepageData());
  const recommendations = dispatch(fetchAdvertiseRecommendations());
  return Promise.all([homepage, recommendations]);
};

export default Homepage;
